$(document).ready(function(){
	
	$(".sectionCta.sectionLogin.js-loginTrigger").click(function(){
		
		var toLink = $(this).attr('href');
		if(toLink == "#login"){
	
			$(".new-menu.content-target.js-content-target").toggleClass("loginActive");
		}else{
			$(".new-menu.content-target.js-content-target").removeClass("loginActive");
		}
	});
})